export var TriggerTypeEnum;
(function (TriggerTypeEnum) {
    TriggerTypeEnum["EVENT"] = "event";
})(TriggerTypeEnum || (TriggerTypeEnum = {}));
